import React from 'react'

const close_icon = require('static/close-icon.png')
const close_icon_hover = require('static/close-icon-hover.png')

export interface ICloseIconProps {
  onClick: () => void
}

export default function CloseIcon({ onClick }: ICloseIconProps) {
  return (
    <span className="close-icon" onClick={onClick}>
      <style jsx>
        {`
        .close-icon{
          height: 16px;
          width: 16px;
          position: absolute;
          top: 8px;
          right: 8px;
          background-size: contain;
          background-position: center;
          background-image: url("${close_icon}");
          z-index: 1;
        }
        .close-icon:hover{
          background-image: url("${close_icon_hover}");
          cursor: pointer;
        }
      `}
      </style>
    </span>
  )
}
